
<script>
    export default {
        props: ['items', 'title']
    }
</script>
<template>
    <div class="breadcrumb-area bg-img" :style="{'background-image':'url(assets/img/backgrounds/funfact-bg.jpg)'}">
        <div class="container">
            <div class="row">
                <div class="col">
                    <div class="page-banner text-center">
                        <h2 class="font-size">{{ title }}</h2>
                        <b-breadcrumb class="page-breadcrumb" :items="items"></b-breadcrumb>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
